import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { fetchRedeemData } from '../../services/api';
import '../../styles/output.css';
import '../../styles/index.css';
import { SideMenu,Header,TopMenu } from 'maxcu-shared-lib';
import menuItems from '../SideMenu/menuItems';

function Redeem() {
  const [redeemData, setRedeemData] = useState(null);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const [isCollapsed, setIsCollapsed] = useState(false);

  useEffect(() => {
    let isMounted = true;
    document.title = "Rewards Redemption Options | MAX Credit Union";
    const getData = async () => {
      try {
        const result = await fetchRedeemData();
        setTimeout(() => {
          if (isMounted){
            setRedeemData(result);
          }
        },1000);
        
      } catch (err) {
        if (isMounted){
          setError(err);
        }
      }
    };
    getData();

    const handleResize = () => {
      if (window.innerWidth < 600) {
        setIsCollapsed(true);
      } else {
        setIsCollapsed(false);
      }
    };

    handleResize(); // Set initial state

    window.addEventListener('resize', handleResize);
    
    return () => {
      isMounted=false;
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  if (error) return <div>Error: {error.message}</div>;
  if (!redeemData) return <div className='text-center'>Loading...</div>;

  const handleCopyCode = () => {
    if (redeemData?.referral_code) {
      navigator.clipboard.writeText(redeemData.referral_code)
        .then(() => {
          alert('Referral Code Copied!');
          // Or use a more modern notification approach:
          // setNotification('Referral Code Copied!');
        })
        .catch(err => {
          console.error('Failed to copy:', err);
        });
    }
  };
  const handleCopyLink = () => {
    if (redeemData?.referral_code) {
      navigator.clipboard.writeText('mymax.com/referrals?id=' + redeemData.referral_code + '&n=' + redeemData.first_name)
        .then(() => {
          alert('Referral Link Copied!');
          // Or use a more modern notification approach:
          // setNotification('Referral Code Copied!');
        })
        .catch(err => {
          console.error('Failed to copy:', err);
        });
    }
  };


  return (
    <div style={{ display: 'flex' }}>
      <SideMenu menuItems={menuItems} />
      <div style={{ flex: 1 }} className={`${isCollapsed ? 'sb-thin' : 'sb-wide'}`}>
      <Header name="Redemption Options" />
      {isCollapsed && <TopMenu />}
      <div class='sb-body'>
      {redeemData?.memo_post_mode === 'NO' && redeemData?.redeem_off === 'NO' && parseFloat(redeemData?.pts_available_count.replace(/,/g, '')) >= 500 ? (
        <div className="mx-auto md:max-w-3xl md:grid md:grid-cols-1 md:gap-4">

        <div className="bg-gray-100 p-6 rounded-md mb-2 sm:mb-4">
          <div>
            <p className="p-redeem text-gray-900 text-lg text-center">You have a total of</p>
            <h2 className="h2-redeem text-gray-900 text-5xl text-center tracking-tighter relative">{ redeemData.pts_available_count }</h2>
            <p className="p-redeem text-gray-900 text-lg text-center">to Redeem</p>
            <p className="p-redeem text-gray-900 text-md text-center">Select how you'd like to redeem your points below. </p>
          </div>
        </div>

        <div className="mx-auto sm:max-w-3xl md:grid md:grid-cols-2 md:gap-4 mb-2 md:mb-4">
        <div className="bg-green-100 p-6 rounded-md mb-2 sm:mb-4">
          <div>
          <h2 className="text-h2-referral text-2xl text-center tracking-tight leading-6 font-bold mb-4">Cash!</h2>
            <p className="p-redeem text-green-900 text-lg text-center">Redeem { redeemData.pts_available_count } points for</p>
            <h2 className="h2-redeem text-green-900 text-5xl text-center tracking-tighter relative"><span className="absolute text-2xl -ml-4">$</span>{ redeemData.pts_available_worth }</h2>
  
            <div className="mt-6">
              <button 
                 onClick={() => navigate('/redeemcash')} 
                 className="btn-redeem mt-2 inline-block w-full bg-blue-600 border border-transparent rounded-md py-2 text-sm font-bold text-white text-center hover:bg-blue-700 hover:text-white"
              >
                  Redeem All Points for Cash
              </button> 
            </div>
  
            <p className="text-green-900 text-xs text-center mt-4">(After redemption, your points balance will be zero.)</p>
          </div>
        </div>

        <div className="bg-blue-100 p-6 rounded-md mb-2 sm:mb-4">
          <div>
          <h2 className="text-h2-referral text-2xl text-center tracking-tight leading-6 font-bold mb-4">Donate!</h2>
            <p className="p-redeem text-blue-900 text-lg text-center">Donate a portion of your { redeemData.pts_available_count } points to a participating Charity</p>
  
            <div className="mt-6">
              <button 
                 onClick={() => navigate('/redeemdonate')} 
                 className="btn-redeem mt-2 inline-block w-full bg-blue-600 border border-transparent rounded-md py-2 text-sm font-bold text-white text-center hover:bg-blue-700 hover:text-white"
              >
                  Donate a Portion of your Points to Charity
              </button> 
            </div>
  
          </div>
        </div>
        </div>

                <div className="mx-auto md:max-w-3xl md:grid md:grid-cols-2 md:gap-4">
                  <div className="bg-gray-50 p-6 rounded-md mb-2 sm:mb-4">
                    <div>
                      <h2 className="text-h2-referral text-2xl text-center tracking-tight leading-6 font-bold mb-4">Share the reward of membership. Refer a friend and get rewarded!</h2>
                      <p className="text-sm text-center"><strong>Referring is easy and starts here!</strong> Earn 5,000 points for both you and your friend. Copy the referral code and share, it's that easy.</p>
                    </div>
                  </div>
                  
                  <div className="bg-blue-100 p-6 rounded-md mb-2 sm:mb-4">
                    <div>
                      <p className="p-nomargin text-blue-900 text-sm text-center">Your referral code is</p>
                      <h2 id="displayCode" className="text-refcode text-blue-900 text-5xl text-center tracking-tighter font-bold">{ redeemData.referral_code }</h2>
              
                      <div className="flex justify-center mb-6">
                      <button
                        onClick={handleCopyCode}
                        className="copy-button mt-2 inline-block w-1/2 bg-blue-600 border border-transparent rounded-full py-1 px-3 text-sm font-bold text-white text-center hover:bg-blue-700"
                      >
                        Copy Code
                      </button>
                      </div>
              
                      <p className="p-nomargin text-blue-900 text-sm text-center">Your referral link is</p>
                      <h2 id="displayLink" className="text-reflink text-blue-900 text-xl text-center tracking-tighter font-bold">mymax.com/referrals?id={ redeemData.referral_code }&n={ redeemData.first_name }</h2>
              
                      <div className="flex justify-center">
                        <button
                          onClick={handleCopyLink}
                          className="copy-button mt-2 inline-block w-1/2 bg-blue-600 border border-transparent rounded-full py-1 px-3 text-sm font-bold text-white text-center hover:bg-blue-700"
                        >
                          Copy Link
                        </button>

                      </div>
                    </div>
                  </div>
                  
                </div>

      </div>  

      ) : (
        <div>
          <div className="mx-auto md:max-w-3xl md:grid md:grid-cols-1 md:gap-4">

            <div className="bg-green-100 p-6 rounded-md mb-2 sm:mb-4">
              <div>
                <div className="mt-6">
                    <div className="text-comeback" id="comeBack">Redemption Off. <br />Come back later.</div>
                </div>

              
              </div>
            </div>
          </div>

        </div>
      )}
      </div>
      </div>
    </div>
  );
}

export default Redeem;